import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Siempre activas (no se pueden desactivar)
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    // Verificar si el usuario ya aceptó/rechazó cookies
    const consent = localStorage.getItem('seguria_cookie_consent');
    if (!consent) {
      // Mostrar banner después de 1 segundo
      setTimeout(() => setShowBanner(true), 1000);
    } else {
      // Cargar preferencias guardadas
      try {
        const savedPrefs = JSON.parse(consent);
        setPreferences(savedPrefs);
        // Aplicar preferencias (ej: inicializar analytics si está permitido)
        if (savedPrefs.analytics) {
          initializeAnalytics();
        }
      } catch (e) {
        console.error('Error loading cookie preferences:', e);
      }
    }
  }, []);

  const initializeAnalytics = () => {
    // Aquí se inicializaría Google Analytics o la herramienta que uses
    console.log('Analytics initialized');
    // Ejemplo: window.gtag('config', 'GA_MEASUREMENT_ID');
  };

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem('seguria_cookie_consent', JSON.stringify(allAccepted));
    setPreferences(allAccepted);
    setShowBanner(false);
    initializeAnalytics();
  };

  const handleRejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    localStorage.setItem('seguria_cookie_consent', JSON.stringify(onlyNecessary));
    setPreferences(onlyNecessary);
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem('seguria_cookie_consent', JSON.stringify(preferences));
    setShowBanner(false);
    setShowPreferences(false);
    if (preferences.analytics) {
      initializeAnalytics();
    }
  };

  const togglePreference = (key) => {
    if (key === 'necessary') return; // No se puede desactivar
    setPreferences(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Banner Principal */}
      {!showPreferences && (
        <div 
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#1a1a1a',
            color: 'white',
            padding: '20px',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
            zIndex: 9999,
            animation: 'slideUp 0.5s ease-out'
          }}
        >
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {/* Texto */}
              <div>
                <h3 style={{ margin: '0 0 10px 0', fontSize: '1.125rem', fontWeight: '600' }}>
                  🍪 Uso de Cookies
                </h3>
                <p style={{ margin: 0, fontSize: '0.875rem', lineHeight: '1.5', opacity: 0.9 }}>
                  Utilizamos cookies necesarias para el funcionamiento del sitio y cookies analíticas para mejorar tu experiencia. 
                  Puedes aceptar todas, rechazar las opcionales o personalizar tus preferencias.
                  {' '}
                  <a 
                    href="/legal/privacy-v1.0.html" 
                    target="_blank" 
                    style={{ color: '#667eea', textDecoration: 'underline' }}
                  >
                    Más información
                  </a>
                </p>
              </div>

              {/* Botones */}
              <div style={{ 
                display: 'flex', 
                gap: '10px', 
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
                <button
                  onClick={handleAcceptAll}
                  style={{
                    backgroundColor: '#667eea',
                    color: 'white',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#5568d3'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
                >
                  Aceptar Todas
                </button>
                
                <button
                  onClick={handleRejectAll}
                  style={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)',
                    padding: '10px 24px',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Solo Necesarias
                </button>

                <button
                  onClick={() => setShowPreferences(true)}
                  style={{
                    backgroundColor: 'transparent',
                    color: '#667eea',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }}
                >
                  Personalizar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Preferencias */}
      {showPreferences && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.7)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            maxWidth: '600px',
            width: '100%',
            maxHeight: '90vh',
            overflow: 'auto',
            padding: '30px',
            position: 'relative'
          }}>
            {/* Header */}
            <div style={{ marginBottom: '25px' }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '1.5rem', color: '#1a1a1a' }}>
                Preferencias de Cookies
              </h2>
              <p style={{ margin: 0, fontSize: '0.875rem', color: '#666' }}>
                Selecciona qué tipos de cookies deseas permitir
              </p>
            </div>

            {/* Cookies Necesarias */}
            <div style={{
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              marginBottom: '15px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: '0 0 8px 0', fontSize: '1rem', color: '#1a1a1a' }}>
                    Cookies Necesarias
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.875rem', color: '#666' }}>
                    Esenciales para el funcionamiento del sitio. Incluyen autenticación, sesión y seguridad.
                  </p>
                </div>
                <div style={{
                  marginLeft: '15px',
                  padding: '6px 12px',
                  backgroundColor: '#10b981',
                  color: 'white',
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: '600'
                }}>
                  SIEMPRE ACTIVAS
                </div>
              </div>
            </div>

            {/* Cookies Analíticas */}
            <div style={{
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              marginBottom: '15px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: '0 0 8px 0', fontSize: '1rem', color: '#1a1a1a' }}>
                    Cookies Analíticas
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.875rem', color: '#666' }}>
                    Nos ayudan a entender cómo usas el sitio para mejorar tu experiencia. Datos anónimos y agregados.
                  </p>
                </div>
                <label style={{ marginLeft: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={() => togglePreference('analytics')}
                    style={{ 
                      width: '20px', 
                      height: '20px', 
                      cursor: 'pointer',
                      accentColor: '#667eea'
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Cookies de Marketing */}
            <div style={{
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              marginBottom: '25px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: '0 0 8px 0', fontSize: '1rem', color: '#1a1a1a' }}>
                    Cookies de Marketing
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.875rem', color: '#666' }}>
                    Se usan para personalizar anuncios y medir su efectividad. Pueden ser compartidas con terceros.
                  </p>
                </div>
                <label style={{ marginLeft: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={preferences.marketing}
                    onChange={() => togglePreference('marketing')}
                    style={{ 
                      width: '20px', 
                      height: '20px', 
                      cursor: 'pointer',
                      accentColor: '#667eea'
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Botones */}
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowPreferences(false)}
                style={{
                  backgroundColor: 'transparent',
                  color: '#666',
                  border: '1px solid #e5e7eb',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleSavePreferences}
                style={{
                  backgroundColor: '#667eea',
                  color: 'white',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Guardar Preferencias
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default CookieBanner;
